export type Content = {
	theme: Theme;
	menuTexts: string[];
	puzzles: PartialPuzzleData[];
	defaultPuzzle: PuzzleData;
};

export type Theme = {
	background: { color: string; text: string; link: string };
	primary: { color: string; text: string; link: string };
	logo: string;
};

export type PuzzleSize = {
	x: number;
	y: number;
	aspect: number;
	overlap: number;
};

export type PartialPuzzleData = {
	name: string;
	title: string;
	sizes?: PuzzleSize[];
	winTexts?: string[];
};

export type PuzzleData = {
	name: string;
	title: string;
	sizes: PuzzleSize[];
	winTexts: string[];
};

const Themes: { [key: string]: Content } = {
	default: {
		theme: {
			background: { color: '#e0f2fe', text: '#3b82f6', link: '#d946ef' },
			primary: { color: '#38bdf8', text: '#ffffff', link: '#3b82f6' },
			logo: '',
		},
		menuTexts: ['СОБЕРИ ПАЗЛ!', 'Листай картинки, чтобы выбрать пазл со своими любимыми персонажами!'],
		puzzles: [
			// { name: 'coco', title: 'Coco' },
			// { name: 'forest', title: 'Forest' },
			// { name: 'kikoriki3', title: 'Смешарики' },
			// { name: 'luca', title: 'Luca' },
			// { name: 'song', title: 'Song of the Sea' },
			// { name: 'wolf', title: 'Wolfwalkers' },
			{ name: 'barbos', title: 'Барбоскины' },
			{ name: 'barbos2', title: 'Барбоскины' },
			{ name: 'bodo', title: 'Бодо Бородо' },
			{ name: 'buka', title: 'Бука. Моё любимое чудище' },
			{ name: 'buka2', title: 'Бука. Моё любимое чудище' },
			{ name: 'chikchirikino1', title: 'Чикчирикино' },
			{ name: 'chikchirikino2', title: 'Чикчирикино' },
			{ name: 'chikchirikino3', title: 'Чикчирикино' },
			{ name: 'dinocity', title: 'ДиноСити' },
			{ name: 'enotki', title: 'Енотки' },
			{ name: 'eralash', title: 'Ералаш' },
			{ name: 'fixiki', title: 'Фиксики' },
			{ name: 'flora', title: 'Команда Флоры' },
			{ name: 'katyaief', title: 'Катя и Эф' },
			{ name: 'kikoriki', title: 'Смешарики' },
			{ name: 'kikoriki2', title: 'Смешарики' },
			{ name: 'kitchen', title: 'Волшебная кухня' },
			{ name: 'kitchen2', title: 'Волшебная кухня' },
			{ name: 'koshey', title: 'Кощей. Начало' },
			{ name: 'luntik', title: 'Лунтик и его друзья' },
			{ name: 'luntik2', title: 'Лунтик и его друзья' },
			{ name: 'malish', title: 'Малышарики' },
			{ name: 'malish2', title: 'Малышарики' },
			{ name: 'masha', title: 'Маша и Медведь' },
			{ name: 'meow', title: 'Супер МЯУ' },
			{ name: 'mimimi', title: 'Ми-ми-мишки' },
			{ name: 'nik', title: 'Ник-изобретатель' },
			{ name: 'nik2', title: 'Ник-изобретатель' },
			{ name: 'nupogodi', title: 'Ну, погоди!' },
			{ name: 'orangecow', title: 'Оранжевая корова' },
			{ name: 'patrol', title: 'Сказочный патруль' },
			{ name: 'prosto', title: 'Простоквашино' },
			{ name: 'suvorov', title: 'Суворов: Великое путешествие' },
			{ name: 'tribogat', title: 'Три богатыря и Конь на троне' },
			{ name: 'tribogat2', title: 'Три богатыря и Конь на троне' },
			{ name: 'turbo', title: 'Турбозавры' },
			{ name: 'turbo2', title: 'Турбозавры' },
			{ name: 'turtles', title: 'Черепашки' },
			{ name: 'turtles2', title: 'Черепашки' },
			{ name: 'tzar', title: 'Царевны' },
			{ name: 'tzar2', title: 'Царевны' },
		],
		defaultPuzzle: {
			name: 'puzzle',
			title: 'Пазл',
			sizes: [
				{ x: 3, y: 2, aspect: 0.889, overlap: 0.2 },
				{ x: 4, y: 3, aspect: 1, overlap: 0.2 },
				{ x: 5, y: 4, aspect: 1.067, overlap: 0.2 },
			],
			winTexts: ['ПОЛУЧИЛОСЬ!', 'Молодец. Попробуй другие пазлы в нашем разделе [«Игры»](https://www.karusel-tv.ru/games/group/7)'],
		},
	},
	glavgeroi: {
		theme: {
			background: { color: '#1a0ffd', text: '#ffffff', link: '#97ff2d' },
			primary: { color: '#97ff2d', text: '#181c51', link: '#d335c2' },
			logo: '/images/themes/glavgeroilogo.png',
		},
		menuTexts: [
			'СОБЕРИ ПАЗЛ!',
			'Листай картинки, чтобы выбрать пазл со своими любимыми Главными Героями!',
		],
		puzzles: [
			{ name: 'barbos', title: 'Барбоскины' },
			{ name: 'barbos2', title: 'Барбоскины' },
			{ name: 'bodo', title: 'Бодо Бородо' },
			{ name: 'buka', title: 'Бука. Моё любимое чудище' },
			{ name: 'buka2', title: 'Бука. Моё любимое чудище' },
			{ name: 'chikchirikino1', title: 'Чикчирикино' },
			{ name: 'chikchirikino2', title: 'Чикчирикино' },
			{ name: 'chikchirikino3', title: 'Чикчирикино' },
			{ name: 'dinocity', title: 'ДиноСити' },
			{ name: 'enotki', title: 'Енотки' },
			{ name: 'eralash', title: 'Ералаш' },
			{ name: 'fixiki', title: 'Фиксики' },
			{ name: 'flora', title: 'Команда Флоры' },
			{ name: 'katyaief', title: 'Катя и Эф' },
			{ name: 'kikoriki', title: 'Смешарики' },
			{ name: 'kikoriki2', title: 'Смешарики' },
			{ name: 'kitchen', title: 'Волшебная кухня' },
			{ name: 'kitchen2', title: 'Волшебная кухня' },
			{ name: 'koshey', title: 'Кощей. Начало' },
			{ name: 'luntik', title: 'Лунтик и его друзья' },
			{ name: 'luntik2', title: 'Лунтик и его друзья' },
			{ name: 'malish', title: 'Малышарики' },
			{ name: 'malish2', title: 'Малышарики' },
			{ name: 'masha', title: 'Маша и Медведь' },
			{ name: 'meow', title: 'Супер МЯУ' },
			{ name: 'mimimi', title: 'Ми-ми-мишки' },
			{ name: 'nik', title: 'Ник-изобретатель' },
			{ name: 'nik2', title: 'Ник-изобретатель' },
			{ name: 'nupogodi', title: 'Ну, погоди!' },
			{ name: 'orangecow', title: 'Оранжевая корова' },
			{ name: 'patrol', title: 'Сказочный патруль' },
			{ name: 'prosto', title: 'Простоквашино' },
			{ name: 'suvorov', title: 'Суворов: Великое путешествие' },
			{ name: 'tribogat', title: 'Три богатыря и Конь на троне' },
			{ name: 'tribogat2', title: 'Три богатыря и Конь на троне' },
			{ name: 'turbo', title: 'Турбозавры' },
			{ name: 'turbo2', title: 'Турбозавры' },
			{ name: 'turtles', title: 'Черепашки' },
			{ name: 'turtles2', title: 'Черепашки' },
			{ name: 'tzar', title: 'Царевны' },
			{ name: 'tzar2', title: 'Царевны' },
		],
		defaultPuzzle: {
			name: 'puzzle',
			title: 'Пазл',
			sizes: [
				{ x: 3, y: 2, aspect: 0.889, overlap: 0.2 },
				{ x: 4, y: 3, aspect: 1, overlap: 0.2 },
				{ x: 5, y: 4, aspect: 1.067, overlap: 0.2 },
			],
			winTexts: [
				'ПОЛУЧИЛОСЬ!',
				'Ты молодец! Попробуешь собрать еще один пазл?',
			],
		},
	},
};

export default Themes;
